import DashboardCard from "../../../ui/DashboardCard/DashboardCard";
import type { BusinessListingResponse } from "../../../../types/businessListingTypes";
import { formatCityStateZip } from "../../../../utils/LocationUtils";
import { formatBusinessListingJobType } from "../../../../utils/BusinessListingUtils";

type BusinessListingsBoxProps = {
  listings: BusinessListingResponse[];
  loading: boolean;
};

const listingStatusLabel: Record<BusinessListingResponse["status"], string> = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
  EXPIRED: "Expired",
  CLOSED: "Closed",
};

const BusinessListingsBox = ({ listings, loading }: BusinessListingsBoxProps) => {
  return (
    <DashboardCard
      title="Job Listings"
      subtitle="Active and draft business listings in one place."
      to="/adult/gigs"
    >
      {loading ? (
        <p className="text-sm text-myteengig-text-muted">Loading job listings...</p>
      ) : listings.length === 0 ? (
        <p className="text-sm text-myteengig-text-muted">No listings yet. Create your first listing to start sharing your hiring needs.</p>
      ) : (
        <ul className="space-y-3">
          {listings.slice(0, 3).map((listing) => (
            <li key={listing.id} className="rounded-lg border border-myteengig-border bg-myteengig-background p-3">
              <p className="text-center font-semibold text-myteengig-text-primary">{listing.title}</p>
              <p className="mt-1 text-center text-sm text-myteengig-text-muted">
                {formatBusinessListingJobType(listing.jobType)} • {listing.category}
              </p>
              <p className="mt-2 text-center text-sm text-myteengig-text-muted">{formatCityStateZip(listing)}</p>
              <div className="mt-2 flex justify-center">
                <span className="rounded-full border px-2 py-1 text-xs font-semibold text-myteengig-text-primary">
                  {listingStatusLabel[listing.status]}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </DashboardCard>
  );
};

export default BusinessListingsBox;
